/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useMutation, useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  CalendarResponseDto,
  CancelCalendarEventDto,
  DataEnvelopeOfCalendarEventDto,
  DataEnvelopeOfCalendarReportDto,
  DataEnvelopeOfListOfCalendarEventDto,
  GetCalendarEventsParams,
  PinNoticeDto,
  SaveCalendarEventDto,
  UpdateCalendarEventParams,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const pinNotice = (
  id: string,
  pinNoticeDto: PinNoticeDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/v1/communications/${id}/pin`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: pinNoticeDto,
      signal,
    },
    options,
  )
}

export const getPinNoticeMutationKey = () => ['pinNotice'] as const

export const getPinNoticeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pinNotice>>,
    TError,
    PinNoticeMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof pinNotice>>,
  TError,
  PinNoticeMutationVariables,
  TContext
> => {
  const mutationKey = getPinNoticeMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pinNotice>>,
    PinNoticeMutationVariables
  > = (props) => {
    const { id, data } = props ?? {}

    return pinNotice(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PinNoticeMutationResult = NonNullable<Awaited<ReturnType<typeof pinNotice>>>
export type PinNoticeMutationBody = PinNoticeDto
export type PinNoticeMutationError = unknown
export type PinNoticeMutationVariables = { id: string; data: PinNoticeDto }

export const usePinNotice = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof pinNotice>>,
      TError,
      PinNoticeMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof pinNotice>>,
  TError,
  PinNoticeMutationVariables,
  TContext
> => {
  return useMutation(getPinNoticeMutationOptions(options), queryClient)
}
export const getCalendarEvents = (
  params: GetCalendarEventsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfListOfCalendarEventDto>(
    { url: `/v1/calendar/events`, method: 'GET', params, signal },
    options,
  )
}

export const getGetCalendarEventsQueryKey = (params?: GetCalendarEventsParams) => {
  return [`/v1/calendar/events`, ...(params ? [params] : [])] as const
}

export const getGetCalendarEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCalendarEvents>>,
  TError = unknown,
>(
  params: GetCalendarEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarEvents>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCalendarEventsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCalendarEvents>>> = ({ signal }) =>
    getCalendarEvents(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCalendarEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCalendarEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCalendarEvents>>
>
export type GetCalendarEventsQueryError = unknown

export function useGetCalendarEvents<
  TData = Awaited<ReturnType<typeof getCalendarEvents>>,
  TError = unknown,
>(
  params: GetCalendarEventsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarEvents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendarEvents>>,
          TError,
          Awaited<ReturnType<typeof getCalendarEvents>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCalendarEvents<
  TData = Awaited<ReturnType<typeof getCalendarEvents>>,
  TError = unknown,
>(
  params: GetCalendarEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarEvents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendarEvents>>,
          TError,
          Awaited<ReturnType<typeof getCalendarEvents>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCalendarEvents<
  TData = Awaited<ReturnType<typeof getCalendarEvents>>,
  TError = unknown,
>(
  params: GetCalendarEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarEvents>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCalendarEvents<
  TData = Awaited<ReturnType<typeof getCalendarEvents>>,
  TError = unknown,
>(
  params: GetCalendarEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarEvents>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCalendarEventsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const createCalendarEvent = (
  saveCalendarEventDto: SaveCalendarEventDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfListOfCalendarEventDto>(
    {
      url: `/v1/calendar/events`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: saveCalendarEventDto,
      signal,
    },
    options,
  )
}

export const getCreateCalendarEventMutationKey = () => ['createCalendarEvent'] as const

export const getCreateCalendarEventMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCalendarEvent>>,
    TError,
    CreateCalendarEventMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCalendarEvent>>,
  TError,
  CreateCalendarEventMutationVariables,
  TContext
> => {
  const mutationKey = getCreateCalendarEventMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCalendarEvent>>,
    CreateCalendarEventMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return createCalendarEvent(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateCalendarEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCalendarEvent>>
>
export type CreateCalendarEventMutationBody = SaveCalendarEventDto
export type CreateCalendarEventMutationError = unknown
export type CreateCalendarEventMutationVariables = { data: SaveCalendarEventDto }

export const useCreateCalendarEvent = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCalendarEvent>>,
      TError,
      CreateCalendarEventMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCalendarEvent>>,
  TError,
  CreateCalendarEventMutationVariables,
  TContext
> => {
  return useMutation(getCreateCalendarEventMutationOptions(options), queryClient)
}
export const getCalendarEvent = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCalendarEventDto>(
    { url: `/v1/calendar/events/${id}`, method: 'GET', signal },
    options,
  )
}

export const getGetCalendarEventQueryKey = (id: string) => {
  return [`/v1/calendar/events/${id}`] as const
}

export const getGetCalendarEventQueryOptions = <
  TData = Awaited<ReturnType<typeof getCalendarEvent>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarEvent>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCalendarEventQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCalendarEvent>>> = ({ signal }) =>
    getCalendarEvent(id, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCalendarEvent>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetCalendarEventQueryResult = NonNullable<Awaited<ReturnType<typeof getCalendarEvent>>>
export type GetCalendarEventQueryError = unknown

export function useGetCalendarEvent<
  TData = Awaited<ReturnType<typeof getCalendarEvent>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarEvent>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendarEvent>>,
          TError,
          Awaited<ReturnType<typeof getCalendarEvent>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCalendarEvent<
  TData = Awaited<ReturnType<typeof getCalendarEvent>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarEvent>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendarEvent>>,
          TError,
          Awaited<ReturnType<typeof getCalendarEvent>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCalendarEvent<
  TData = Awaited<ReturnType<typeof getCalendarEvent>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarEvent>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCalendarEvent<
  TData = Awaited<ReturnType<typeof getCalendarEvent>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarEvent>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCalendarEventQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const updateCalendarEvent = (
  id: string,
  saveCalendarEventDto: SaveCalendarEventDto,
  params?: UpdateCalendarEventParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfListOfCalendarEventDto>(
    {
      url: `/v1/calendar/events/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: saveCalendarEventDto,
      params,
      signal,
    },
    options,
  )
}

export const getUpdateCalendarEventMutationKey = () => ['updateCalendarEvent'] as const

export const getUpdateCalendarEventMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCalendarEvent>>,
    TError,
    UpdateCalendarEventMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCalendarEvent>>,
  TError,
  UpdateCalendarEventMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateCalendarEventMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCalendarEvent>>,
    UpdateCalendarEventMutationVariables
  > = (props) => {
    const { id, data, params } = props ?? {}

    return updateCalendarEvent(id, data, params, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateCalendarEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCalendarEvent>>
>
export type UpdateCalendarEventMutationBody = SaveCalendarEventDto
export type UpdateCalendarEventMutationError = unknown
export type UpdateCalendarEventMutationVariables = {
  id: string
  data: SaveCalendarEventDto
  params?: UpdateCalendarEventParams
}

export const useUpdateCalendarEvent = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCalendarEvent>>,
      TError,
      UpdateCalendarEventMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCalendarEvent>>,
  TError,
  UpdateCalendarEventMutationVariables,
  TContext
> => {
  return useMutation(getUpdateCalendarEventMutationOptions(options), queryClient)
}
export const deleteCalendarEvent = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/v1/calendar/events/${id}`, method: 'DELETE', signal },
    options,
  )
}

export const getDeleteCalendarEventMutationKey = () => ['deleteCalendarEvent'] as const

export const getDeleteCalendarEventMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCalendarEvent>>,
    TError,
    DeleteCalendarEventMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCalendarEvent>>,
  TError,
  DeleteCalendarEventMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteCalendarEventMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCalendarEvent>>,
    DeleteCalendarEventMutationVariables
  > = (props) => {
    const { id } = props ?? {}

    return deleteCalendarEvent(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteCalendarEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCalendarEvent>>
>

export type DeleteCalendarEventMutationError = unknown
export type DeleteCalendarEventMutationVariables = { id: string }

export const useDeleteCalendarEvent = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCalendarEvent>>,
      TError,
      DeleteCalendarEventMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCalendarEvent>>,
  TError,
  DeleteCalendarEventMutationVariables,
  TContext
> => {
  return useMutation(getDeleteCalendarEventMutationOptions(options), queryClient)
}
export const cancelCalendarEvent = (
  id: string,
  cancelCalendarEventDto: CancelCalendarEventDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/v1/calendar/events/${id}/cancel`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: cancelCalendarEventDto,
      signal,
    },
    options,
  )
}

export const getCancelCalendarEventMutationKey = () => ['cancelCalendarEvent'] as const

export const getCancelCalendarEventMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelCalendarEvent>>,
    TError,
    CancelCalendarEventMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelCalendarEvent>>,
  TError,
  CancelCalendarEventMutationVariables,
  TContext
> => {
  const mutationKey = getCancelCalendarEventMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelCalendarEvent>>,
    CancelCalendarEventMutationVariables
  > = (props) => {
    const { id, data } = props ?? {}

    return cancelCalendarEvent(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type CancelCalendarEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelCalendarEvent>>
>
export type CancelCalendarEventMutationBody = CancelCalendarEventDto
export type CancelCalendarEventMutationError = unknown
export type CancelCalendarEventMutationVariables = { id: string; data: CancelCalendarEventDto }

export const useCancelCalendarEvent = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelCalendarEvent>>,
      TError,
      CancelCalendarEventMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cancelCalendarEvent>>,
  TError,
  CancelCalendarEventMutationVariables,
  TContext
> => {
  return useMutation(getCancelCalendarEventMutationOptions(options), queryClient)
}
export const respondToCalendarEvent = (
  id: string,
  calendarResponseDto: CalendarResponseDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/v1/calendar/events/${id}/response`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: calendarResponseDto,
      signal,
    },
    options,
  )
}

export const getRespondToCalendarEventMutationKey = () => ['respondToCalendarEvent'] as const

export const getRespondToCalendarEventMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof respondToCalendarEvent>>,
    TError,
    RespondToCalendarEventMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof respondToCalendarEvent>>,
  TError,
  RespondToCalendarEventMutationVariables,
  TContext
> => {
  const mutationKey = getRespondToCalendarEventMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof respondToCalendarEvent>>,
    RespondToCalendarEventMutationVariables
  > = (props) => {
    const { id, data } = props ?? {}

    return respondToCalendarEvent(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type RespondToCalendarEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof respondToCalendarEvent>>
>
export type RespondToCalendarEventMutationBody = CalendarResponseDto
export type RespondToCalendarEventMutationError = unknown
export type RespondToCalendarEventMutationVariables = { id: string; data: CalendarResponseDto }

export const useRespondToCalendarEvent = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof respondToCalendarEvent>>,
      TError,
      RespondToCalendarEventMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof respondToCalendarEvent>>,
  TError,
  RespondToCalendarEventMutationVariables,
  TContext
> => {
  return useMutation(getRespondToCalendarEventMutationOptions(options), queryClient)
}
export const readCalendarEvent = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/v1/calendar/events/${id}/read`, method: 'POST', signal },
    options,
  )
}

export const getReadCalendarEventMutationKey = () => ['readCalendarEvent'] as const

export const getReadCalendarEventMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof readCalendarEvent>>,
    TError,
    ReadCalendarEventMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof readCalendarEvent>>,
  TError,
  ReadCalendarEventMutationVariables,
  TContext
> => {
  const mutationKey = getReadCalendarEventMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof readCalendarEvent>>,
    ReadCalendarEventMutationVariables
  > = (props) => {
    const { id } = props ?? {}

    return readCalendarEvent(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ReadCalendarEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof readCalendarEvent>>
>

export type ReadCalendarEventMutationError = unknown
export type ReadCalendarEventMutationVariables = { id: string }

export const useReadCalendarEvent = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof readCalendarEvent>>,
      TError,
      ReadCalendarEventMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof readCalendarEvent>>,
  TError,
  ReadCalendarEventMutationVariables,
  TContext
> => {
  return useMutation(getReadCalendarEventMutationOptions(options), queryClient)
}
export const getCalendarReport = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCalendarReportDto>(
    { url: `/v1/calendar/events/${id}/report`, method: 'GET', signal },
    options,
  )
}

export const getGetCalendarReportQueryKey = (id: string) => {
  return [`/v1/calendar/events/${id}/report`] as const
}

export const getGetCalendarReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getCalendarReport>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarReport>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCalendarReportQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCalendarReport>>> = ({ signal }) =>
    getCalendarReport(id, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCalendarReport>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetCalendarReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCalendarReport>>
>
export type GetCalendarReportQueryError = unknown

export function useGetCalendarReport<
  TData = Awaited<ReturnType<typeof getCalendarReport>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarReport>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendarReport>>,
          TError,
          Awaited<ReturnType<typeof getCalendarReport>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCalendarReport<
  TData = Awaited<ReturnType<typeof getCalendarReport>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarReport>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendarReport>>,
          TError,
          Awaited<ReturnType<typeof getCalendarReport>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCalendarReport<
  TData = Awaited<ReturnType<typeof getCalendarReport>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarReport>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCalendarReport<
  TData = Awaited<ReturnType<typeof getCalendarReport>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarReport>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCalendarReportQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const exportCalendarParticipants = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/v1/calendar/events/${id}/participants.csv`, method: 'GET', signal },
    options,
  )
}

export const getExportCalendarParticipantsQueryKey = (id: string) => {
  return [`/v1/calendar/events/${id}/participants.csv`] as const
}

export const getExportCalendarParticipantsQueryOptions = <
  TData = Awaited<ReturnType<typeof exportCalendarParticipants>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportCalendarParticipants>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getExportCalendarParticipantsQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportCalendarParticipants>>> = ({
    signal,
  }) => exportCalendarParticipants(id, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof exportCalendarParticipants>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type ExportCalendarParticipantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportCalendarParticipants>>
>
export type ExportCalendarParticipantsQueryError = unknown

export function useExportCalendarParticipants<
  TData = Awaited<ReturnType<typeof exportCalendarParticipants>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportCalendarParticipants>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportCalendarParticipants>>,
          TError,
          Awaited<ReturnType<typeof exportCalendarParticipants>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportCalendarParticipants<
  TData = Awaited<ReturnType<typeof exportCalendarParticipants>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportCalendarParticipants>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportCalendarParticipants>>,
          TError,
          Awaited<ReturnType<typeof exportCalendarParticipants>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportCalendarParticipants<
  TData = Awaited<ReturnType<typeof exportCalendarParticipants>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportCalendarParticipants>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExportCalendarParticipants<
  TData = Awaited<ReturnType<typeof exportCalendarParticipants>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportCalendarParticipants>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getExportCalendarParticipantsQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const exportCalendarEvent = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/v1/calendar/events/${id}/calendar.ics`, method: 'GET', signal },
    options,
  )
}

export const getExportCalendarEventQueryKey = (id: string) => {
  return [`/v1/calendar/events/${id}/calendar.ics`] as const
}

export const getExportCalendarEventQueryOptions = <
  TData = Awaited<ReturnType<typeof exportCalendarEvent>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCalendarEvent>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getExportCalendarEventQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportCalendarEvent>>> = ({ signal }) =>
    exportCalendarEvent(id, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof exportCalendarEvent>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type ExportCalendarEventQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportCalendarEvent>>
>
export type ExportCalendarEventQueryError = unknown

export function useExportCalendarEvent<
  TData = Awaited<ReturnType<typeof exportCalendarEvent>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportCalendarEvent>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportCalendarEvent>>,
          TError,
          Awaited<ReturnType<typeof exportCalendarEvent>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportCalendarEvent<
  TData = Awaited<ReturnType<typeof exportCalendarEvent>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportCalendarEvent>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportCalendarEvent>>,
          TError,
          Awaited<ReturnType<typeof exportCalendarEvent>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportCalendarEvent<
  TData = Awaited<ReturnType<typeof exportCalendarEvent>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCalendarEvent>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExportCalendarEvent<
  TData = Awaited<ReturnType<typeof exportCalendarEvent>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCalendarEvent>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getExportCalendarEventQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
